import React, { Component } from 'react'
import { createStyles, WithStyles, withStyles, Card, CardHeader, IconButton, CardContent, Chip, Typography } from '@material-ui/core'
import { connect } from 'react-redux'
import { Dispatch } from 'redux';
import MuiTheme from '../../MuiTheme';
import { ReduxStore } from '../../stores';
import { Chapter } from './@types';

interface IStateProps { }

interface IDispatchProps { }

interface IState { }

interface IProps extends WithStyles<typeof STYLES>, IStateProps, IDispatchProps {
    chapter: Chapter
    onClose?: () => void
}

class ChapterDetailCard extends Component<IProps, IState> {

    render() {
        const { classes, chapter } = this.props
        return (
            <div className={classes.root} >
                <Card>
                    <CardHeader
                        title={`${chapter.number}. ${chapter.name}`}
                        action={
                            <IconButton onClick={this.props.onClose} ><i className={'material-icons'} >close</i></IconButton>
                        }
                    />
                    <CardContent>
                        <div className={classes.keywordsContainer} >
                            {
                                chapter?.keywords?.map((keyword, index) => {
                                    return <Chip key={index} color='primary' label={keyword} />
                                })
                            }
                        </div>
                        <Typography variant='body1' >{chapter.description}</Typography>
                    </CardContent>
                </Card>
            </div>
        )
    }
}

const mapStateToProps = (state: ReduxStore): IStateProps => ({

})

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => ({

})

const STYLES = (theme: typeof MuiTheme) => createStyles({
    root: {
        width: 350
    },
    keywordsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        '& > div': {
            marginRight: 4, marginBottom: 4
        }
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(STYLES)(ChapterDetailCard))